<template>
  <div class="icon-trigger" style="display: inline-block">
    <div v-tooltip="title">
      <font-awesome-icon class="fa-fw" icon="info-circle" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'InfoWithTooltip',
  props: {
    title: { type: String, required: true },
  },
};
</script>

<style scoped></style>
